var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 299 c-133 -132 -177 -181 -190 -215 -9 -25 -15 -48 -12 -51 3 -3 26 3 51 12 34 13 83 57 215 190 167 168 186 196 159 223 -27 27 -55 8 -223 -159z m210 141 c11 -17 -5 -32 -21 -19 -8 6 -14 15 -14 20 0 12 27 11 35 -1z m-27 -67 c-9 -11 -15 -10 -34 8 -19 17 -21 25 -12 36 9 11 15 10 34 -8 19 -17 21 -25 12 -36z m-44 -15 c9 -15 -8 -36 -114 -143 -69 -69 -128 -125 -132 -125 -5 0 -8 7 -8 15 0 8 -7 15 -15 15 -8 0 -15 3 -15 7 0 16 246 253 259 251 8 -2 19 -11 25 -20z m-274 -272 c0 -14 -24 -29 -33 -19 -3 3 -3 11 0 19 7 18 33 18 33 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.754e322aceb52a6bab337163c4a2e836.svg";
export { ForwardRef as ReactComponent };